const getApiBaseUrl = () => {
  if (import.meta.env.VITE_API_BASE_URL) return import.meta.env.VITE_API_BASE_URL
  if (typeof window !== 'undefined' && window.__WIDGET_API_BASE__) return window.__WIDGET_API_BASE__
  return '/api'
}

const withLang = (url, lang) => {
  if (!lang) return url
  const joiner = url.includes('?') ? '&' : '?'
  return `${url}${joiner}lang=${encodeURIComponent(lang)}`
}

export const fetchCategories = async (lang) => {
  const response = await fetch(withLang(`${getApiBaseUrl()}/calculator/categories/list`, lang))
  if (!response.ok) {
    throw new Error('Failed to fetch categories.')
  }
  return response.json()
}

export const fetchRadiators = async (market, type, lang) => {
  const response = await fetch(
    withLang(
      `${getApiBaseUrl()}/calculator/market/${encodeURIComponent(market)}/${encodeURIComponent(type)}`,
      lang
    )
  )
  if (!response.ok) {
    throw new Error('Failed to fetch radiators.')
  }
  return response.json()
}

export const fetchPanelTypes = async (market, productId, lang) => {
  const response = await fetch(
    withLang(
      `${getApiBaseUrl()}/calculator/market/${encodeURIComponent(
        market
      )}/products/${encodeURIComponent(productId)}/types`,
      lang
    )
  )
  if (!response.ok) {
    throw new Error('Failed to fetch panel types.')
  }
  return response.json()
}

export const fetchPanelMatches = async (market, productId, payload, lang) => {
  const response = await fetch(
    withLang(
      `${getApiBaseUrl()}/calculator/market/${encodeURIComponent(
        market
      )}/products/${encodeURIComponent(productId)}/match`,
      lang
    ),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        __body: JSON.stringify(payload),
      }).toString(),
    }
  )
  if (!response.ok) {
    throw new Error('Failed to fetch panel matches.')
  }
  return response.json()
}

export const fetchProductDetails = async (market, productId, lang) => {
  const response = await fetch(
    withLang(
      `${getApiBaseUrl()}/calculator/market/${encodeURIComponent(
        market
      )}/products/${encodeURIComponent(productId)}`,
      lang
    )
  )
  if (!response.ok) {
    throw new Error('Failed to fetch product details.')
  }
  return response.json()
}

export const navigateToDownload = (productId, lang, ids) => {
  const url = `${getApiBaseUrl()}/export/excel?ids=${encodeURIComponent(ids)}&productId=${encodeURIComponent(productId)}&lang=${encodeURIComponent(lang)}`
  window.location.assign(url)
}
